import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import FlatButton from 'material-ui/FlatButton';
import { translate } from 'react-i18next';
import {List} from 'material-ui/List';
import swal from 'sweetalert';
import {notify} from 'react-notify-toast';
import moment from 'moment';
var Config = require('../../../config');

class ModalBiometrics extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		//this.autoHandleChange = this.autoHandleChange.bind(this);
		this.saveBiometrics = this.saveBiometrics.bind(this);
		this.validateRangeBiometric = this.validateRangeBiometric.bind(this);
		this.acceptNum = this.acceptNum.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.changeCombo = this.changeCombo.bind(this);
		this.onPrint = this.onPrint.bind(this);
		this.printingLabel = this.printingLabel.bind(this);

		this.state = {
			donor_name:"",
			offer_number:"",
			offer_date:"",
		    show: false,
			item: {} , 
			biometrics:[], 
			offer_id:"",
			donor:{
				donor:{},
				person:{},
				offer:{}
			},
			donor_id:"",

			incident:{
				key:"",
				text:""
			},
			incident_type:{
				id:null,
				text:""
			},
			incidents_category:[],
			disable_incidents_cat : false,
			incidents_type:[],
			incident_refused_id:"",
			caller_id:"",
			option:'',

			invalid_sample:"",
			max_length:"4",
			isExtractionComplete: false
		};
	}

	componentDidMount() {
		this.props.onRef(this);

		// incident category lookups?type=incident_type&notRender=0
		fetch(Config.default.apiGateway.URL+'lookups?type=incident_type&notRender=0',{
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			}) 
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				incidents_category: response
			})

			this.selectIncident();

		})
	}

	//selecciona extraction por defecto
	selectIncident(){
		this.state.incidents_category.map(function(i){
			
			if(i.key === 'INCIDENT_BIOMETRICOS'){
				const incident = this.state.incident;
				incident.key   = i.key;
				incident.text = i.name;

				this.setState({
					incident:incident,
					disable_incidents_cat:true
				});

				this.getIncidentType(i.key);
			}
		}.bind(this));
	}

	getIncidentType = (key)=>{
		fetch(Config.default.apiGateway.URL+'incidents?option='+key, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				incidents_type:response
			})
		})
	}

	onIncidentSelected = (e)=>{
		//this.handleChange(e);
		
		const incident = this.state[e.target.name];	

		if(e.target.name === 'incident'){
			incident.key   = e.target.value;
			incident.text  = e.target.options[e.target.selectedIndex].text

			this.setState({
				incident : incident
			});
			this.getIncidentType(e.target.value);
		
		}else{
			incident.id    = e.target.value;
			incident.text  = e.target.options[e.target.selectedIndex].text

			this.setState({
				incident_type : incident
			});
		}
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	handleShow(id,donor, caller_id, isExtractionComplete) {//console.log(donor)
		this.setState({
			caller_id: caller_id, show: true,
			offer_id: id,
			item: {},
			biometrics: [],
			incident_type: { id: null },
			isExtractionComplete: isExtractionComplete
		});
		this.getDonor(donor,id);
	}


	getDonor(donor_id, offer_id){
		//donor
		fetch(Config.default.apiGateway.URL+'donors?id='+donor_id+'&offer_id='+offer_id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({donor:response });

			this.getBiometrict(response.person.sex);
		})
	}

	getBiometrict (sex){
		fetch(Config.default.apiGateway.URL+'biometrics?option=BIO_F_BIO&sex='+sex,{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
	    })
	    .then(response => response.json())
	    .then(response => {
	      //console.log(response)
	      for (var i = 0; i < response.length; i++) {
	      	response[i].offer_id = this.state.offer_id;
	      };
	      this.setState({biometrics: response});
	      setTimeout(function() { //Start the timer
		  	this.getBiometrictsData(); //After 1 second, set render to true
		  	for(var j =0;j<response.length;j++){
		  		document.getElementById(response[j].id).required = response[j].required;
		  	}
		  }.bind(this), 500)
	    })
	}

	getBiometrictsData(){
		fetch(Config.default.apiGateway.URL+'biometrics_data/by_offer?id='+this.state.offer_id+'&form_type=BIO_F_BIO',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
	    })
	   	.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error, Lectura Biometría Hemática!', result, 'error');
              });
            }})
	    .then(response => {
	    	if(response !== undefined){
	    		var values = response.values;
	    		if(response.incident_id !== undefined){
		    		this.setState({
	    				incident_type:{
	    					id:response.incident_id
	    				},
	    				invalid_sample:true
	    			});
		    	}
	    		if(response.incident !== null && response.incident !== undefined){
					this.setState({
						incident_refused_id:response.incident.id
					});
				}
		      	for(var i =0; i < values.length;i++){
					if(values[i].value !== null){
						document.getElementById(values[i].biometrics_id).value = parseFloat(values[i].value);
				
						var index = this.state.biometrics.findIndex(obj => obj.id === values[i].id);

						this.calculateValuesBIO({
							target:{
								id: values[i].biometrics_id,
								value: values[i].value,
								required: index !== -1 ? this.state.biometrics[index].required : false
							}
						});
					}else{
						document.getElementById(values[i].biometrics_id).value = values[i].value_text;
					}

					
		      	}

				
		      	if(values.length > 0){
	      			this.setState({option:'update'});
		      	}else{
		      		this.setState({option:'save'});
				  }
				  
				this.setState({
					donor_name:response.donor_name,
					offer_number:response.offer_id,
					offer_date:moment(response.timestamp_date).format('DD/MM/YYYY')
				});

		      	this.setState({
		      		invalid_sample: response.sample_valid === null ? '':
		      						response.sample_valid ? 'SI' :
		      						!response.sample_valid ? 'NO' : ''
		      	});

		      	if(this.props.task_biometrics.create && this.props.task_biometrics.update){
		      		this.setState({option:'todos'});
		      	}
	      	}
	    })
	}

	calculateValuesBIO(e){
		this.validateRangeBiometric(e.target.id, e.target.value);
		for (var i = 0; i < this.state.biometrics.length; i++) {
			if (this.state.biometrics[i].data_type === "BIO_D_CALCULATED") {
				var str = (this.state.biometrics[i].formula).split('&');				
				document.getElementById(this.state.biometrics[i].id).value = this.getTerms(str);

				this.validateRangeBiometric(this.state.biometrics[i].id, this.getTerms(str));
			};
		};

		
		if(e.target.value.toString().indexOf('.') !== -1){
			this.setState({max_length: "5"});
		}else{
			this.setState({max_length: "4"});
		}

		if(e.target.id !== null){
			var control = document.getElementById(e.target.id);
			if(control !== null){
				if(e.target.value !== ""){
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
					}
				}else{
					if(control.required){
						control.classList.add('error');
					}
					
				}
			}
			
		}
	}

	validateRangeBiometric(id, value){
		
		for(var i =0; i < this.state.biometrics.length;i++){
			
				
			if(id.toString() === this.state.biometrics[i].id.toString()){
				if(this.state.biometrics[i].ranges_validation){//Si el biometrico tiene rango de valores
					var aux = parseFloat(value);
					if(this.state.donor.person.sex === "HOMBRE"){//Valores para hombre
						//Desmarcar el color rojo del control
			
						if(aux >= this.state.biometrics[i].low_rank_male && aux <= this.state.biometrics[i].high_rank_male){
							document.getElementById(id).style.borderColor = "#ccc";
						}else{//Si esta fuera de rango marcar el control de color rojo
							document.getElementById(id).style.borderColor = "red";
						}
					}else{//Valores para mujer
						//Desmarcar el color rojo del control
			
						if(aux >= this.state.biometrics[i].low_rank_female && aux <= this.state.biometrics[i].high_rank_female){
							document.getElementById(id).style.borderColor = "#ccc";
						}else{//Si esta fuera de rango marcar el control de color rojo
							document.getElementById(id).style.borderColor = "red";
						}
					}
				}	
			}
		}
	}

	getTerms(term){
		var result = "";
		var formula = "";
		
		for (var i = 0; i < term.length; i++) {
			var id = parseFloat( term[i] );
			if (!isNaN(id) && term[i].indexOf('+') === -1) {
				formula = formula + this.getItemValue(id);
			}else {
				formula = formula + term[i];
			};

			
		};

		try{
			result =  eval(formula);
		}catch(e){
			//swal('Error', 'Verifique todos sus valores antes de calcular','error');
			return "";
		}

		if (!isNaN(result)) {
			return (result).toFixed(2);
		} else{
			return "";
		};
		
	}

	getItemValue(id){
		if(document.getElementById(id) !== null){
			return document.getElementById(id).value;	
		}else{
			return "";
		}
	}

	saveBiometrics(e){
		if(this.isValidForm() === true){
			var temp = [];
			var value = "";
			for (var i = 0; i < this.state.biometrics.length; i++) {
				
				value = document.getElementById(this.state.biometrics[i].id).value;
				if (value !== "") {
					var obj = {};
					obj.biometrics_id = this.state.biometrics[i].id;
					obj.offers_id = this.state.biometrics[i].offer_id;

					if(this.state.biometrics[i].data_type === 'BIO_D_SELECT' || this.state.biometrics[i].data_type === 'BIO_D_OPEN'){
						obj.value_text = value;
					}else{
						obj.value = value;
					}
					
					temp.push(obj);
				};
					
			};

			var send = {};
			send.values = temp;
			send.offer_id = this.state.offer_id;
			send.type = "BIO_F_BIO";
			send.sample_valid = this.state.invalid_sample === "" ? null :
								this.state.invalid_sample === 'SI' ? true :
								this.state.invalid_sample === 'NO' ? false : null

			if(this.state.incident_refused_id === ""){
				send.incident_id = this.state.incident_type.id !== null && this.state.incident_type.id !== "" ?
									 parseInt(this.state.incident_type.id,10):0;
			}

			this.props.waiting.handleShow('Guardando...');
			fetch(Config.default.apiGateway.URL+'biometrics_data', {
			  method: 'POST', // or 'PUT'
			  body: JSON.stringify(send), // data can be `string` or {object}!
			  headers: new Headers({
			  	'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
			  	'Accept': 'application/json',
			  	'Content-Type': 'application/json;charset=UTF-8'
			  })
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}console.log(res)})
			.catch(error => console.error('Error:', error))
			.then(response => {
		    	if(response !== undefined){
		    		notify.show('Valores Biometría Hemática Guardados','success');
					//this.printReg();
		    		this.handleClose();
		    		if(this.props.refresh !== undefined){
		    			this.props.refresh();
		    		}
		    	}else{
		    		swal('Error', 'No se pudo guardar','error');
		    	}
			});
		}else{
			swal('¡Error!', 'Campos Incompletos', 'error');
		}
	} 
printReg(){
	fetch(Config.default.apiGateway.URL+'html_templates?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+'&file_type=label_register&extraction_type=',{ 
		method: 'get',
		headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token"), 
			   'Accept': 'application/json',
			'Content-Type': 'application/json',
		})
	}).then(res => {
		if(res.ok){
		  return res.json();
		}else{
		  res.text().then(function(result) {
			swal('¡Error!', result, 'error');
		  });
		}}).then(response => {
			console.log(response);
								console.log(this.state.offer_id)
								this.setState({
									register_id:this.state.offer_id,
									label_type: "label_register",
									ficha:null,
								})
								this.printingLabel([]);
					})
}

printingLabel(etiqueta){
	console.log(etiqueta)
	var obj ={
		health_facilities_id : sessionStorage.getItem("health_facilities_id"),
		id : this.state.offer_id.toString(),
		file_type : "label_register",
		nEtiqueta : etiqueta,
		name : this.state.type_extraction_name,// == "SANGE TOTAL"?"SANGRE_TOTAL":"AFÉRESIS";
	}
	console.log(obj)
	this.props.waiting.handleShow('Imprimiendo...');
	fetch(Config.default.apiGateway.URL+'labelsEditor',{
		
		method : 'post',
		body:JSON.stringify(obj),
		responseType: 'blob', //Force to receive data in a Blob Format
		headers : new Headers({
			'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
			'Content-Type': 'application/json'
		})
	}).then(res => {
		this.props.waiting.handleClose();
		if(res.ok){
			return res.blob();
		}else{
		  res.text().then(function(result) {
			  if(this.state.ficha == null){
				swal('¡Error!', result, 'error');
			  }else{
				swal('Error', 'No se pudo imprimir la etiqueta de la ficha #'+this.state.ficha, 'error');
			  }
			
			return;
		  });
		}
	}).then(response => {
		if(response !== undefined){
			
				//PREVIEW
				var fileURL = URL.createObjectURL(response);
				window.open(fileURL);
			
			console.log(this.state.screen !== 'multiple' , 
			this.state.screen !== 'bag_entries' ,
			this.state.label_type !== 'label_caller')
			// if(this.state.screen !== 'multiple' && 
			// 	this.state.screen !== 'bag_entries' &&
			// 	this.state.label_type !== 'label_caller'
				
			// ){
			// 	this.traceability();	
			// }
			
			this.handleClose();
		   }
	})
}
	//Verificar si el formulario es valido
	isValidForm() {
		//const ctrls = document.querySelectorAll('input,select');
		const select = document.querySelector('div.modal-body');
		const ctrls = select.querySelectorAll('input, select');
	    let isFormValid = true;

	    ctrls.forEach(ctrl => {
	    	if(ctrl.required){
		      	const isInputValid = this.showCtrlError(ctrl.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });

	    return isFormValid;
	}

	showCtrlError(refName) {
		//console.log(refName+' is required');
		var res = null;
		var control = document.getElementById(refName);
		if (control.value === "") {
	        if(control !== null){
	            control.classList.add('error');
	        }
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
		        	control.classList.remove('error');
		    	}
	    	}
			res = true;
		}

		return res;
	}

	acceptNum(e){//Sólo números y SÓLO 1 punto decimal
		if(e.key === 'Enter'){
			this.validateInput(e);
		}else{
			// Punto = 46
			var key = e.which;
			var cadena= e.target.value
			if(cadena.indexOf('.')===-1){
				if(key <= 13 || (key >= 48 && key <= 57) || key == 46){
					return;
				}else{
					e.preventDefault();
				}
			}else{
				if(key <= 13 || (key >= 48 && key <= 57)){
					return;
				}else{
					e.preventDefault();
				}
			}
		}
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;

      		const index = Array.prototype.indexOf.call(form, e.target);
      		if(form.elements[index + 1] !== undefined){

      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
    				if(form.elements[index + 1].getAttribute("disabled") === null)
    					form.elements[index + 1].focus();
    			
    				else if(form.elements[index + 1].getAttribute("disabled") === "")
    					form.elements[index + 2].focus();
    			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	handleChange(e){
  		this.setState({invalid_sample:e.target.value});
  	}


	changeCombo(e, i){
		var biometrics = this.state.biometrics;

		biometrics[i].value = e.target.value;

		this.setState({biometrics: biometrics});
	}

	async onPrint(e){
    	e.preventDefault();

		this.props.waiting.handleShow('Imprimiendo...');
          
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = this.state.offer_id;
		obj.file_type = 'biometric_results';
		obj.nEtiqueta = [0];

		var type = await this.props.getDocumentType(obj.file_type);
		var document;
		if(type !== undefined){
			if(type.print_type === 'template'){
				document = await this.props.printDocumentTemplate(obj, type.print_automatically);
			}else if(type.print_type === 'external'){
				document = await this.props.printDocumentExternal(obj, type.print_automatically);
			}
				
			this.props.waiting.handleClose();
			
		}else{
			this.props.waiting.handleClose();
		}
		
  	}

	render(){
		const { t } = this.props;

		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.biometrics.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body style={{fontSize: "11px",}}>
		        	<form noValidate>
			        	<div className="row" >
							<div className="col-xs-12">
								<label style={{marginRight:8}}>Donador: </label>
								<span className="span-min">{this.state.donor_name}</span>
							</div>
							<div className="col-xs-6">
								<label style={{marginRight:8}}>Ofrecimiento: </label>
								<span className="span-min">{this.state.offer_number}</span>
							</div>
							<div className="col-xs-6">
								<label style={{marginRight:8}}>Fecha: </label>
								<span className="span-min">{this.state.offer_date}</span>
							</div>
			        		<div className="col-xs-12">
			        			<List>
		        				{this.state.biometrics.map( (t, index) => (
									<div className="col-xs-12 form-group" key={index}>
				        				<div className="col-xs-offset-2 col-xs-2" style={{padding:'0px'}}>
					        				<span>{t.name}:</span>
					        			</div>
					        			<div className="col-xs-6 col-sm-3">
											{t.data_type === 'BIO_D_SELECT' ? 
												<select name={t.id} id={t.id} value={t.value} className="form-control"
													required={t.required}
													onChange={(e)=>this.changeCombo(e, index)}
													disabled={(this.state.option === 'save' ? !this.props.task_biometrics.create : 
														this.state.option === 'update' ? !this.props.task_biometrics.update :
														this.state.option === 'todos' ? false : true)}
												>
													<option value="">Seleccione...</option>
													{t.biometrics_options.map((option, i)=>
														<option value={option.value} key={i}>{option.value}</option>
													)}
												</select>
											: t.data_type === 'BIO_D_OPEN' ?
												<input 
													name={t.id} 
													id={t.id} 
													value={t.value} 
													maxLength={50}
													//onKeyPress={this.acceptNum}
													onChange={(e) => this.changeCombo(e, index)}
													type="text" className="form-control"
													disabled={this.state.isExtractionComplete || (this.state.option === 'save' ? !this.props.task_biometrics.create : 
														this.state.option === 'update' ? !this.props.task_biometrics.update :
														this.state.option === 'todos' ? false : true)}
													required={t.required}
												/>
											:
												<input 
													name={t.id} 
													id={t.id} 
													value={t.value} 
													style={{textAlign:'right'}}
													maxLength={this.state.max_length}
													onKeyPress={this.acceptNum}
													onChange={(e) => this.calculateValuesBIO(e)}
													type="text" className="form-control"
													disabled={this.state.isExtractionComplete || t.data_type === "BIO_D_CALCULATED" || 
														(this.state.option === 'save' ? !this.props.task_biometrics.create : 
														this.state.option === 'update' ? !this.props.task_biometrics.update :
														this.state.option === 'todos' ? false : true)}
													required={t.required}
												/>
											}
					        			</div>
										<div className="col-xs-4 col-sm-3">
											<span className="span-min">{t.units}</span>
										</div>
				        			</div>
								))}
			        			</List>
			        			<div className="col-xs-12 form-group">
			        				<div className="col-xs-offset-2 col-xs-2" style={{padding:"0px"}}>
							        	<span>Muestra Válida</span>
							       	</div>
				        			<div className="col-xs-6 col-sm-3">
				        				<select name="invalid_sample" id="invalid_sample" value={this.state.invalid_sample}
				        					onChange={this.handleChange} className="form-control" disabled={this.state.isExtractionComplete}>
				        					<option value="">Seleccione...</option>
				        					<option value="SI">SI</option>
				        					<option value="NO">NO</option>
				        				</select>
			        				</div>
			        			</div>
			        			{this.state.invalid_sample === 'NO' ?
			        				<div className="col-xs-12 form-group">
								        <div className="col-xs-offset-2 col-xs-2" style={{padding:"0px"}}>
								        	<span>Motivo:</span>
								       	</div>
								       	<div className="col-xs-6 col-sm-3">
											<select className="form-control" value={ this.state.incident_type.id || ""} 
									        	onChange={ this.onIncidentSelected } name="incident_type" id="incident_type" disabled={this.state.isExtractionComplete}>
								              	<option value="">Seleccionar...</option>
								                {
									                this.state.incidents_type.map(function(t) {
									                	return <option key={t.id} value={t.id} >{t.name}</option>;
									                })
								            	}
								            </select>
								        </div>
							        </div>
			        			:null}
			        				
				 			</div>
						</div>
					</form>
						
		        </Modal.Body>
		        <Modal.Footer>
					<FlatButton primary={true} label={t('content.generics.buttons.print')} 
						onClick={this.onPrint}
					/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')} 
		        		onClick={this.saveBiometrics} keyboardFocused={true} 
		        		disabled={this.state.option === 'save' ? !this.props.task_biometrics.create : 
		        			this.state.option === 'update' ? !this.props.task_biometrics.update :
		        			this.state.option === 'todos' ? false : true}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalBiometrics) 